'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var reactIntl = require('react-intl');
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var InputWithTopLabel = require('../InputWithTopLabel/InputWithTopLabel.js');
var SelectWithTopLabel = require('../SelectWithTopLabel/SelectWithTopLabel.js');
var styledComponents = require('./styled-components.js');
var constants = require('./constants.js');
var validators = require('./validators.js');

var AddressInput = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = props.activateValidation, activateValidation = _g === void 0 ? false : _g, initialData = props.initialData, _h = props.reportCollectedErrors, reportCollectedErrors = _h === void 0 ? function () { } : _h, reporter = props.reporter, titleComponent = props.titleComponent;
    var fm = reactIntl.useIntl().formatMessage;
    var fmBase = 'componentLib.addressInput';
    var validators$1 = validators.getAllValidators(fm);
    var _j = React.useState({
        address1: (_a = initialData === null || initialData === void 0 ? void 0 : initialData.address1) !== null && _a !== void 0 ? _a : '',
        address2: (_b = initialData === null || initialData === void 0 ? void 0 : initialData.address2) !== null && _b !== void 0 ? _b : '',
        city: (_c = initialData === null || initialData === void 0 ? void 0 : initialData.city) !== null && _c !== void 0 ? _c : '',
        zipCode: (_d = initialData === null || initialData === void 0 ? void 0 : initialData.zipCode) !== null && _d !== void 0 ? _d : '',
        state: (_e = initialData === null || initialData === void 0 ? void 0 : initialData.state) !== null && _e !== void 0 ? _e : '',
        country: (_f = initialData === null || initialData === void 0 ? void 0 : initialData.country) !== null && _f !== void 0 ? _f : '',
    }), data = _j[0], setStateData = _j[1];
    var validationErrors = React.useRef({
        address1: [],
        city: [],
        state: [],
        zipCode: [],
    });
    var setData = function (newData) {
        setStateData(newData);
        if (reporter) {
            var reportData_1 = tslib.__assign({}, data);
            if (reportData_1.state === 'default') {
                reportData_1.state = '';
            }
            reporter(reportData_1);
        }
    };
    var collectErrors = function (fieldName, errors) {
        var _a;
        var newErrors = tslib.__assign(tslib.__assign({}, validationErrors.current), (_a = {}, _a[fieldName] = errors, _a));
        validationErrors.current = newErrors;
        if (reportCollectedErrors) {
            reportCollectedErrors(newErrors);
        }
    };
    var reportData = function (key, arg0) {
        var _a;
        setData(tslib.__assign(tslib.__assign({}, data), (_a = {}, _a[key] = arg0, _a)));
    };
    var reportAddress1 = function (newValue) {
        reportData('address1', newValue);
    };
    var reportAddress2 = function (newValue) {
        reportData('address2', newValue);
    };
    var reportCity = function (newValue) {
        reportData('city', newValue);
    };
    var reportZipCode = function (newValue) {
        reportData('zipCode', newValue);
    };
    var reportState = function (args0) {
        var _a;
        reportData('state', (_a = constants.StateCountryHash[args0 || '']) !== null && _a !== void 0 ? _a : 'US');
    };
    var translationFor = function (name) { return fm({ id: fmBase + "." + name }); };
    return (React__default.createElement("div", null,
        React__default.createElement(styledComponents.InputDiv, null,
            React__default.createElement(InputWithTopLabel, { title: titleComponent || translationFor('address') + "*", value: data.address1, reporter: reportAddress1, placeholder: translationFor('address1Placeholder'), validators: validators$1.address1, reportErrors: function (errors) { return collectErrors('address1', errors); }, activateValidation: activateValidation })),
        React__default.createElement(styledComponents.InputDiv, null,
            React__default.createElement(InputWithTopLabel, { value: data.address2 || '', reporter: reportAddress2, placeholder: translationFor('address2Placeholder') })),
        React__default.createElement(Grid, { container: true, spacing: 1 },
            React__default.createElement(Grid, { xs: 6, item: true },
                React__default.createElement(InputWithTopLabel, { value: data.city, reporter: reportCity, placeholder: translationFor('cityPlaceholder'), validators: validators$1.city, reportErrors: function (errors) { return collectErrors('city', errors); }, activateValidation: activateValidation })),
            React__default.createElement(Grid, { xs: 3, item: true, style: { paddingLeft: '3px', paddingRight: '3px' } },
                React__default.createElement(SelectWithTopLabel, { title: '', menuItems: constants.States, placeholder: translationFor('statePlaceholder'), reporter: reportState, defaultValue: data.state, validators: validators$1.state, activateValidation: activateValidation, reportErrors: function (errors) { return collectErrors('state', errors); } })),
            React__default.createElement(Grid, { xs: 3, item: true },
                React__default.createElement(InputWithTopLabel, { value: data.zipCode, reporter: reportZipCode, placeholder: translationFor('zipCodePlaceholder'), validators: validators$1.zipCode, reportErrors: function (errors) { return collectErrors('zipCode', errors); }, activateValidation: activateValidation })),
            React__default.createElement(Grid, { container: true }))));
};

module.exports = AddressInput;
